import React, { Component } from "react";
import "./style.less";

class View extends Component {
    constructor() {
        super(...arguments)
        const { interval = 5000 } = this.props;
        // 转动间隔
        this.interval = interval;
        this.state = {
            index: 0
        }
    }
    componentDidMount() {
        const { rotate = false } = this.props;
        if (rotate) this.rotate();
    }
    rotate = () => {
        const timer = setInterval(() => {
            let { index } = this.state;
            const { rotate = false, items = [] } = this.props;
            // 处于旋转状态 && 条数大于1
            if (!rotate || items.length === 1) return clearInterval(timer);
            this.setState({ index: ++index });
        }, this.interval || 2000)
    }
    componentWillReceiveProps({ rotate, items }) {
        // 旋转状态更新 && 条数大于1
        if (!this.props.rotate && rotate && items.length > 1) this.rotate();
    }
    render() {

        const { index } = this.state;
        const { className = "", style = {}, items = [], height = 40 } = this.props
        const length = items.length;
        // 平均角度
        const angle = Math.round(360 / length);
        const totalHeight = Math.sqrt(Math.pow(height, 2) - Math.pow(height / 2, 2));
        const insideHeight = length === 4 ? height / 2 
            : length > 4 ? totalHeight : totalHeight / 3;

        return (
            <div className={`con-rectangle3D ${className}`} style={{
                height: height + "px",
                ...style,
                transform: `rotateX(${360 / length * index}deg)`,
                WebkitTransformOriginZ: -insideHeight + "px",
                WebkitTransformOriginY: height / 2 + "px",
            }}>
                {items.map((val, i) => (
                    <div className="con-rectangle3D__item" style={{
                        height: height + "px",
                        transform: `translateZ(-${insideHeight}px) rotateX(${angle * i}deg) translateZ(${insideHeight}px)`
                    }}>{val}</div>
                ))}
            </div>
        )
    }
}
export default View;
